export default __webpack_public_path__ + "static/media/qr.18161f95.svg";